import { BillingTransactionTypeEnum } from '@api/READ_ONLY/billing_api/Api';

/**
 * How a billing movement is named, wherever it is listed.
 *
 * Its own module rather than living beside the ledger table: the client card's
 * billing drawer lists the same movements and must name them identically, and
 * importing the table to get one function pulls the whole data-grid in with it.
 */
export const getRecordTypeLabelKey = (recordType: BillingTransactionTypeEnum): string => {
  if (recordType === BillingTransactionTypeEnum.ClientPayment) return 'collection-from-client';
  if (recordType === BillingTransactionTypeEnum.ClientCharge) return 'client-charge';
  if (recordType === BillingTransactionTypeEnum.DoctorPayout) return 'payment-to-doctor';
  if (recordType === BillingTransactionTypeEnum.CaregiverPayout) return 'payment-to-caregiver';
  if (recordType === BillingTransactionTypeEnum.DoctorAccrual) return 'doctor-earnings';
  if (recordType === BillingTransactionTypeEnum.CashCollection) return 'cash-collected';
  if (recordType === BillingTransactionTypeEnum.CashDeposit) return 'cash-deposit';
  return 'caregiver-earnings';
};
